/** Resolve a venue's wall-clock time independently of the member device timezone. */
export function venueSlot(date: string, time: string, duration: string, timezone: string): { starts_at: string; ends_at: string } {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{2}:\d{2}$/.test(time))
    throw new Error("Précisez une date AAAA-MM-JJ et une heure HH:MM.");
  const [year, month, day] = date.split("-").map(Number);
  const [hour, minute] = time.split(":").map(Number);
  const wall = Date.UTC(year, month - 1, day, hour, minute);
  const parsed = new Date(wall);
  if (parsed.getUTCFullYear() !== year || parsed.getUTCMonth() !== month - 1 || parsed.getUTCDate() !== day || hour > 23 || minute > 59)
    throw new Error("Cette date ou cette heure est invalide.");
  const minutes = Number(duration);
  if (!Number.isInteger(minutes) || minutes <= 0 || minutes > 10080)
    throw new Error("La durée choisie est invalide.");
  let formatter: Intl.DateTimeFormat;
  try {
    formatter = new Intl.DateTimeFormat("en-GB", { timeZone: timezone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
  } catch { throw new Error("Le fuseau horaire de cet espace doit être précisé par l’équipe."); }
  function parts(at: number) {
    const entries = formatter.formatToParts(new Date(at));
    const values = Object.fromEntries(entries.map(part => [part.type, part.value]));
    return { year: Number(values.year), month: Number(values.month), day: Number(values.day), hour: Number(values.hour), minute: Number(values.minute) };
  }
  // Sample both sides of possible DST transitions; verify every candidate exactly.
  const offsets = new Set([-36, 0, 36].map(hours => {
    const at = wall + hours * 3600000;
    const p = parts(at);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute) - at;
  }));
  const matches = [...offsets].map(offset => wall - offset).filter(at => {
    const p = parts(at);
    return p.year === year && p.month === month && p.day === day && p.hour === hour && p.minute === minute;
  });
  if (matches.length !== 1)
    throw new Error("Cette heure est ambiguë ou inexistante au changement d’heure. Choisissez un autre créneau.");
  return { starts_at: new Date(matches[0]).toISOString(), ends_at: new Date(matches[0] + minutes * 60000).toISOString() };
}
export function venueDate(value: string, timezone: string): string {
  try { return new Intl.DateTimeFormat("fr-FR", { timeZone: timezone, dateStyle: "medium", timeStyle: "short" }).format(new Date(value)); }
  catch { return "Date à vérifier"; }
}
